<template>
    <ies-form-field :field="field">
        <div class="d-flex flex-column">
            <input type="hidden" :name="field.fieldName" :value="field.value">

            <v-radio-group
                v-model="bookingSystem"
                row
                autocomplete>
                <v-radio label="Email - Quote and Availability on Request"	:value="0"></v-radio>
                <v-radio label="Web - Quote and Availability on Request"	:value="1"></v-radio>
                <v-radio label="Instant Online Availability"				:value="2"></v-radio>
            </v-radio-group>
        </div>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-input-booking-system',
    props: ['field', 'recordData'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
			bookingSystem: parseInt(this.field.value),
        }
    },
	created: function() {
		this.getBookingSystem();
	},
	methods: {
		getBookingSystem() {
			axios.get('/api/booking-system/' + this.recordData.hotel_key).then(function(response) {
				console.log(response.data.book_via_email);
				console.log(response.data.book_via_web);
				console.log(response.data.book_via_instant);

				this.bookingSystem = response.data.book_via_email	? 0 : this.bookingSystem;
				this.bookingSystem = response.data.book_via_web		? 1 : this.bookingSystem;
				this.bookingSystem = response.data.book_via_instant	? 2 : this.bookingSystem;
			}.bind(this));
		},
	},
	watch: {
		bookingSystem: function (newValue) {
			this.field.value = newValue;
		}
	}	
}
</script>
